import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ScreenService } from '@app/shared/services';
/**
 * Modos de visualizações
 */
export type ViggoCoreSearchHeaderViewMode = 'GRID' | 'CARD';

/**
 * @description
 * Localização do preview no locastorage
 */
export const PREVIEWKEYLOCALSTORAGE = 'previewtype';

@Component({
  selector: 'viggo-core-controls-view-type',
  templateUrl: './controls-view-type.component.html',
  styleUrls: ['./controls-view-type.component.scss']
})
export class ControlsViewTypeComponent implements AfterViewInit, OnInit {
  @Input() mobileOnly = false;
  @Input() desktopOnly = false;
  /**
   * @description
   * Tipo de vizualização selecionada
   */
  public previewType: ViggoCoreSearchHeaderViewMode = 'GRID';

  /**
   * Evento executado quando é alterado o modo de visualização
   */
  @Output() onChangeViewMode: EventEmitter<
    ViggoCoreSearchHeaderViewMode
  > = new EventEmitter<ViggoCoreSearchHeaderViewMode>();

  constructor(private screenService: ScreenService) {}

  /**
   * Após identificar qual o dispositivo o sistema corrige a visualização
   * para modo GRID ou CARD
   */
  ngOnInit() {
    this.screenService.deviceType().subscribe(info => {
      this.previewType = info.isMobile ? 'CARD' : 'GRID';
      localStorage.setItem(PREVIEWKEYLOCALSTORAGE, this.previewType);
      this.onChangeViewMode.emit(this.previewType);
    });
  }

  /**
   * Altera o modelo de visualização selecionado
   * @param newViewMode novo modo
   */
  public changePreviewType(newViewMode: ViggoCoreSearchHeaderViewMode) {
    this.previewType = newViewMode;
    localStorage.setItem(PREVIEWKEYLOCALSTORAGE, this.previewType);
    this.onChangeViewMode.emit(this.previewType);
  }
  /**
   * @lifeCycle
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      const previewSaved = localStorage.getItem(
        PREVIEWKEYLOCALSTORAGE
      ) as ViggoCoreSearchHeaderViewMode;

      this.changePreviewType(previewSaved || 'GRID');
    }, 1);
  }
}
